<template>
  <div
    class="zm-tab-pane"
    v-if="(!lazy || loaded) || active"
    v-show="active"
    role="tabpanel"
    :aria-hidden="!active"
    :id="`pane-${paneName}`"
    :aria-labelledby="`tab-${paneName}`"
  >
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'ZmTabPane',

    componentName: 'ZmTabPane',

    props: {
      label: String,
      labelContent: Function,
      name: String,
      closable: Boolean,
      disabled: Boolean,
      lazy: Boolean
    },

    data() {
      return {
        index: null,
        loaded: false
      };
    },

    computed: {
      isClosable() {
        return this.closable || this.$parent.closable;
      },
      active() {
        return this.$parent.currentName === (this.name || this.index);
      },
      paneName() {
        return this.name || this.index;
      }
    },

    watch: {
      label() {
        this.$parent.$forceUpdate();
      },
      active(newVal) {
        if (newVal) {
          this.loaded = true;
        }
      }
    },
    beforeUpdate() {
      if (this.$slots.label && this.$parent.$refs.nav) {
        this.$parent.$refs.nav.$forceUpdate();
      }
    }
  };
</script>

